import { extendDecorator, viewModelDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import template from './assets/template.html';

@viewModelDecorator({
    defaults: {
        tourProducts: [],
    },

    computeds: {
        minimalPercent: {
            deps: ['tourProducts'],
            get(tourProducts) {
                if (!tourProducts?.length) {
                    return '';
                }

                const firstPaymentParts = _.reduce(tourProducts, (acc, tourProduct) => {
                    const firstPaymentPart = tourProduct?.firstPaymentDefinition?.firstPaymentPart;
                    const isUniqValue = !~acc.indexOf(firstPaymentPart);

                    if (isUniqValue && firstPaymentPart) {
                        acc.push(firstPaymentPart);
                    }

                    return acc;
                }, []);

                return _.min(firstPaymentParts);
            },
        },

        minimalPercentText() {
            return Math.round(this.get('minimalPercent') * 100);
        },
    },
})
@extendDecorator({
    template,
    $dialog: null,
    bindings: {
        '.partialPaymentBanner__minPercent': 'text: minimalPercentText',
    },
    partialPaymentBannerDg: null,
})
export default class PartialPaymentHotelBannerView extends Backbone.Epoxy.View {
    initialize(options = {}) {
        const { tourProducts, countryName } = options;
        this.viewModel.set('tourProducts', tourProducts?.toJSON());
        this.viewModel.set('countryName', countryName);

        this.$el.html(this.template());

        if (!window.dataLayer) {
            window.dataLayer = [];
        }

        this.initDOMEvents();
    }

    initDOMEvents() {}
}
